document.addEventListener('DOMContentLoaded', function () {


  //fix sldieshow landingpage
  document.querySelectorAll('div[class*="slideshow-slide"][aria-label]').forEach(slide => {
       slide.setAttribute('role', 'img');
   });
   
  //fix sldieshow landingpage - leere aria labels
   document.querySelectorAll('[aria-label=" "], [aria-label=""]').forEach(el => {
       el.removeAttribute('aria-label');
   });

    //fix toggle checkboxes
   document.querySelectorAll('.comply-ToggleWrapper[role="checkbox"]:not([aria-checked])').forEach(checkbox => {
       checkbox.setAttribute('aria-checked', 'false');
   });

      //fix promo block 
    document.querySelectorAll('.promo-block--content[href]:not([aria-label])').forEach(link => {
       link.setAttribute('aria-label', 'Mehr erfahren');
   });

   document.querySelectorAll('.slideshow-slide__content-background-link:not([aria-label])').forEach(link => {
       link.setAttribute('aria-label', 'Mehr erfahren');
   });

  document.querySelectorAll('li.filter-item').forEach(listItem => {
       const parent = listItem.parentElement;
       
       if (parent && !['UL', 'OL', 'MENU'].includes(parent.tagName)) {
           parent.setAttribute('role', 'list');
           listItem.setAttribute('role', 'listitem');
       }
   });

   document.querySelectorAll('.pagination--item[aria-label="Go to next page"]').forEach(link => {
       link.setAttribute('aria-label', 'Weiter');
   });

   document.querySelectorAll('.pxs-image-with-text-link').forEach(function(link) {
        const button = link.parentElement.querySelector('.pxs-image-with-text-button');
        if (button && !link.textContent.trim()) {
            const hiddenText = document.createElement('span');
            hiddenText.textContent = button.textContent;
            hiddenText.style.cssText = 'position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0;';
            link.appendChild(hiddenText);
        }
    });

   document.querySelectorAll('.product-stock-level__badge-text').forEach(function(element) {
        element.style.color = '#006600';
      
    });
  
 addLandmarkRegions();
  fixProductTitle();
  
  //fix: Filter-Gruppen in <li> elemente
  const filterGroups = document.querySelectorAll('ul.productgrid--sidebar-item');
  filterGroups.forEach(ul => {
    const wrapper = ul.querySelector('.filter-group--wrapper');
    if (!wrapper || wrapper.parentElement.tagName === 'LI') return;
    const liWrapper = document.createElement('li');
    liWrapper.classList.add('filter-group--container');
    liWrapper.appendChild(wrapper);
    ul.insertBefore(liWrapper, ul.firstElementChild === wrapper ? wrapper : null);
    if (wrapper.parentElement === ul) {
      ul.removeChild(wrapper);
    }
  });
  
  //fix: Radio Buttons in <fieldset> gruppieren für Barrierefreiheit
  const swatchContainers = document.querySelectorAll('.productitem--swatches-container');
  if (swatchContainers.length > 0) {
    swatchContainers.forEach(form => {
      if (form.querySelector('fieldset')) return;
      
      const fieldset = document.createElement('fieldset');
      fieldset.style.cssText = 'border:0;padding:0;margin:0;display:contents';
      
      const legend = document.createElement('legend');
      legend.textContent = form.getAttribute('aria-label') || 'Produktoptionen';
      legend.style.cssText = 'position:absolute;left:-9999px';
      
      fieldset.appendChild(legend);
      form.insertBefore(fieldset, form.firstChild);
      [...form.children].slice(1).forEach(child => fieldset.appendChild(child));
    });
  }

  //fix: missing title
  document.querySelectorAll('.countdown__item').forEach(item => {
      const heading = item.querySelector('.countdown__item-heading');
      const label = item.querySelector('.countdown__item-text');
      
      if (heading && label && heading.textContent.trim() === '') {
        const span = document.createElement('span');
        span.classList.add('visually-hidden');
        span.textContent = label.textContent.trim();
        heading.appendChild(span);
      }
    });  

    //fix: h1 missing 
  const existingH1 = document.querySelector('h1');
  if (!existingH1) {
    const h1 = document.createElement('h1');
    h1.classList.add('visually-hidden');

    //fallback
    const pageTitle = document.title || 'Startseite';
    h1.textContent = pageTitle;

    document.body.insertBefore(h1, document.body.firstChild);
  }

  document.querySelectorAll('iframe#PBarNextFrame:not([title])').forEach(iframe => {
    iframe.setAttribute('title', 'Vorschau-Leiste von Shopify');
  });

   document.querySelectorAll('form.shopify-localization-form').forEach(form => {
    if (!form.querySelector('button[type="submit"], input[type="submit"]')) {
      const submit = document.createElement('button');
      submit.type = 'submit';
      submit.classList.add('visually-hidden');
      submit.textContent = 'Absenden';
      form.appendChild(submit);
    }
  });
 


  
   function fixProductTitle() {
    const productTitles = document.querySelectorAll('h2.atc--product-details--title[data-atc-banner-product-title]');
    
    productTitles.forEach(productTitle => {
      if (productTitle.querySelector('.sr-only')) return;
      
      const srText = document.createElement('span');
      srText.classList.add('sr-only');
      srText.textContent = 'Produkttitel: ';
      srText.style.cssText = 'position:absolute!important;width:1px!important;height:1px!important;padding:0!important;margin:-1px!important;overflow:hidden!important;clip:rect(0,0,0,0)!important;white-space:nowrap!important;border:0!important';
      
      productTitle.insertBefore(srText, productTitle.firstChild);
      
      console.log('Product title screen reader text added');
    });
  }

  //fix: landmark regions für bessere Navigation hinzufügen
  function addLandmarkRegions() {
    const header = document.querySelector('header, .site-header, .header');
    if (header && !header.getAttribute('role')) {
      header.setAttribute('role', 'banner');
    }
    
    const nav = document.querySelector('nav, .navigation, .main-nav');
    if (nav && !nav.getAttribute('role')) {
      nav.setAttribute('role', 'navigation');
      if (!nav.getAttribute('aria-label')) {
        nav.setAttribute('aria-label', 'Hauptnavigation');
      }
    }
    
    const main = document.querySelector('main, .main-content, #main');
    if (main && !main.getAttribute('role')) {
      main.setAttribute('role', 'main');
    }
    
    const footer = document.querySelector('footer, .site-footer, .footer');
    if (footer && !footer.getAttribute('role')) {
      footer.setAttribute('role', 'contentinfo');
    }
    
    const search = document.querySelector('.search, .search-form, [data-search]');
    if (search && !search.getAttribute('role')) {
      search.setAttribute('role', 'search');
      if (!search.getAttribute('aria-label')) {
        search.setAttribute('aria-label', 'Produktsuche');
      }
    }
    
    console.log('Landmark regions added (aria only)');
  }

 
});